import { Component, inject, OnInit, output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-requisition-result',
  standalone: true,
  imports: [],
  templateUrl: './modal-requisition-result.component.html',
  styleUrl: './modal-requisition-result.component.scss'
})
export class ModalRequisitionResultComponent implements OnInit {
  
  public data = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef);
  handleConfirmButton = output();
  
  cancelButtonColor?: string;
  confirmButtonColor?: string;
  closeButtonColor?: string = 'red';

  ngOnInit(): void {
    if(this.data.modalType === 'deleteXPTO' ||  this.data.modalType ===  'unableXPTO' && this.data.doubleButton === true){
      this.cancelButtonColor = 'button outline';
      this.confirmButtonColor = 'button red';
    }
    if(this.data.modalType === 'enableXPTO' || this.data.modalType === 'save' && this.data.doubleButton === true) {
      this.cancelButtonColor = 'button outline green';
      this.confirmButtonColor = 'button green';
    }
    if(this.data.modalType === 'editXPTO' && this.data.doubleButton === true){
      this.cancelButtonColor = 'button outline blue';
      this.confirmButtonColor = 'button blue';
    }
    if(this.data.modalType === 'success' && this.data.doubleButton === false){
      this.closeButtonColor = 'button green';
    }
    if(this.data.modalType === 'error' && this.data.doubleButton === false){
      this.closeButtonColor = 'button red';
    }
  } 

  handleConfirmButtonClick() {
    this.handleConfirmButton.emit();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
